import { Dialog, DialogProps } from "../core/components/dialog";
import { Config } from "../core/config/config";
import { FieldInstance } from "../core/components/field";
import { TextBox } from "../core/components/textBox";
import { ComponentHelper } from "../core/util/componentHelper";
import { Helper } from "../core/util/helper";
import { AppHelper } from "../appHelper"
import { FullHeightContainer } from "../core/components/FullHeighContainer";
import { MultiSelect, MultiSelectProps } from "../core/components/multiSelect";
import { HTTPService } from "../core/util/httpManager";
import React from "react";
export class EditTranslationsDialog extends React.Component<editTranslationsDialogProps, editTranslationsDialogState> {
    common = new AppHelper();
    private _factory = ComponentHelper.createFactory();
    private _currentLanguageSelection: Array<{ Language: number, Sprache: string }> = [];
    private _dialogProps: DialogProps = {
        title: "Translations",
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this._loadData(true);
                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    this._saveData();
                },
                primary: true
            }
        ],
        afterClose: () => {
            if (Helper.hasValue(this.props.storageKey)) {
                Helper.removeDataFromStorage(this.props.storageKey);
                Helper.saveDataToStorage(this.props.storageKey, this._currentLanguageSelection, false);
            }

            this.closeDialog();
        },
        width: 500
    };
    private _inputWrapperRef: HTMLDivElement = null;

    constructor(props) {
        super(props);       
        this.state = { dialogOpen: false, translations: [] };
        this._loadFromStorage();
    }

    private _loadFromStorage = () => {
        if (Helper.hasValue(this.props.storageKey)) {
            const loadedLanguages = Helper.loadDataFromStorage(this.props.storageKey);
            if (loadedLanguages != null) {
                this._currentLanguageSelection = loadedLanguages;
                this._loadData();
            }
        }
    }

    private _createLink = () => {
        const labelStyle: React.CSSProperties = {
            cursor: "pointer",
            textDecoration: "Underline"
        }
        const divStyle: React.CSSProperties = {
            display: "flex",
            justifyContent: "flex-end",
            fontSize: "10px",
            marginTop: "2px"

        }
        return (
            <>
                <div style={divStyle}>
                    <label style={labelStyle} onClick={this.openDialog}>{this.props.translations["Parts.TranslationLink.Text"]}</label>
                </div>

            </>
        );
    }

    private _setTextWrapperRef = (r) => {
        this._inputWrapperRef = r;
    }

    private _createDialog = () => {
        if (this.state.dialogOpen) {
            return (
                <div>
                    <Dialog {...this._dialogProps} open={this.state.dialogOpen}>
                        <FullHeightContainer onRef={this._setTextWrapperRef}>
                            {this._createMultiSelect()}
                            {this._createTextBoxes()}
                        </FullHeightContainer>
                    </Dialog>
                </div>
            );
        } else {
            return (<></>);
        }
    }

    private _createMultiSelect = () => {
        let props: MultiSelectProps = this._factory.getDefaultMultiSelectProps();
        props.value = this._currentLanguageSelection;
        props.field.dataSourceUrl = "TranslationsView/GetLanguages";
        props.field.dataValueField = "Language";
        props.field.dataTextField = "Sprache";
        props.onChange = (field: { model: string }, value) => {
            this._currentLanguageSelection = value;
            this._loadData();
        };

        return (
            <FieldInstance label={this.props.translations["WebSMS.Resource.Sprachen"]} noHover={true} >
                <MultiSelect {...props} />
            </FieldInstance>
        );
    }

    private _loadData = (reset: boolean = false) => {
        let lst: number[] = [];
        for (let i = 0; i < this._currentLanguageSelection.length; i++) {
            lst.push(this._currentLanguageSelection[i].Language);
        }
        const data = {
            id: this.props.info.id,
            languages: lst.join("|"),
            context: this.props.info.context
        }
        HTTPService.get("GeneralSettingsLookUp/GetTranslation", data)
            .then(result => {
                if (reset) {
                    this.setState({ translations: result })
                } else {
                    this._updateTranslations(result);
                }
            });
    }

    private _updateTranslations = (newTranslations: translation[]) => {
        let result: translation[] = [];
        let oldTranslations = this.state.translations;
        let translation: translation = null;
        for (let i = 0; i < newTranslations.length; i++) {
            translation = newTranslations[i];
            for (let j = 0; j < oldTranslations.length; j++) {
                if (translation.id == oldTranslations[j].id) {
                    translation = oldTranslations[j];
                    break;
                }
            }
            result.push(translation);
        }
        this.setState({ translations: result })
    }

    private _saveData = () => {
        let url = "GeneralSettingsLookUp/";
        let column: Column = Column.Designation;
        switch (this.props.info.context) {
            case ("identifier"):
                url += "SaveIdentifierTranslation";
                break;
            case ("mainGroup"):
                url += "SaveMainGroupTranslation";
                break;
            case ("mainGroupDescription"):
                url += "SaveMainGroupTranslation";
                column = Column.Description;
                break;
            case ("group"):
                url += "SaveGroupTranslation";
                break;
            case ("groupDescription"):
                url += "SaveGroupTranslation";
                column = Column.Description;
                break;
            case ("ticketUrgency"):
                url += "SaveTicketUrgency";
                break;
        }
        HTTPService.post(url, { id: this.props.info.id, translations: this.state.translations, column: column });
    }

    private _createTextBoxes = () => {
        let elemets = [];
        for (let i = 0; i < this.state.translations.length; i++) {
            const t = this.state.translations[i];
            elemets.push(
                <div key={kendo.guid()} style={{ flexShrink: 0 }}>
                    <FieldInstance label={t.language} noHover={true} >
                        <TextBox {...this._createTextBoxProps(t)} />
                    </FieldInstance>
                </div>
            );
        }
        return elemets;
    }

    private _createTextBoxProps = (t: translation) => {
        let props = this._factory.getDefaultTextBoxProps();
        props.field.name = t.language;
        props.onChange = this.handleTextBoxesChances;
        props.value = t.value;
        if (Helper.hasValue(this.props.maxLenght))
            props.field.maxLength = this.props.maxLenght;
        return (props);
    }

    handleTextBoxesChances = (field: { model: string, name: string }, value: any) => {
        let id: number = 0;
        let translations = this.state.translations;
        for (let i = 0; i < translations.length; i++) {
            if (field.name === translations[i].language) {
                id = i;
            }
        }
        translations[id].value = value;
        this.setState({ translations: translations });
    }

    openDialog = () => {
        if (this.props.checkId()) {
            this.props.onDialogOpen();
            this._loadData(true);
            this.setState({ dialogOpen: true });
        } else {
            this.setState({ dialogOpen: false });
        }
    }

    closeDialog = () => {
        this.props.onDialogClose();
        this.setState({ dialogOpen: false });
    }

    componentDidMount = () => {
        this._dialogProps.title = this.props.translations["Parts.TranslationLink.Title"];
        if (Helper.hasValue(this.props.dialogWidth)) {
            this._dialogProps.width = this.props.dialogWidth;
        }
    }

    render() {
        let link = this._createLink();
        let dialog = this.state.dialogOpen ? this._createDialog() : null;
        return (
            <>
                {link}
                {dialog}
            </>
        );

    }
}

interface editTranslationsDialogState {
    dialogOpen: boolean;
    translations: translation[];
}

interface editTranslationsDialogProps {
    info: ContextInformations;
    onDialogClose: () => void;
    onDialogOpen: () => void;
    checkId: () => boolean;
    dialogWidth?: number;
    translations?: string[];
    storageKey?: string;
    maxLenght?: number;
}

interface ContextInformations {
    id: number;
    context: string;
}

interface translation {
    id: number,
    language: string,
    value: string
}

enum Column {
    Designation,
    Description
}